import { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { RiCheckLine, RiFileCopyLine } from '@remixicon/react';

import { ButtonIcon } from '@backstage/ui';

import { useAlert } from '@spotify/confidence-core-react';

import { MarkdownContent } from '../MarkdownContent';

const useStyles = makeStyles({
  root: {
    padding: 'var(--bui-space-2) 0',
    minWidth: 0,
    position: 'relative',
    '&:hover $copyButton': {
      opacity: 1,
    },
  },
  copyButton: {
    position: 'absolute',
    right: 'calc(var(--bui-space-1) * -1)',
    top: 0,
    opacity: 0,
    transition: 'opacity 150ms ease',
    zIndex: 1,
  },
});

export const AssistantMessage = ({ content }: { content: string }) => {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);
  const alert = useAlert();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (error) {
      alert.post({
        severity: 'error',
        message: 'Could not copy to clipboard.',
      });
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.copyButton}>
        <ButtonIcon
          variant="tertiary"
          size="small"
          icon={
            copied ? <RiCheckLine size={14} /> : <RiFileCopyLine size={14} />
          }
          onPress={handleCopy}
          aria-label="Copy message as markdown"
        />
      </div>
      <MarkdownContent>{content}</MarkdownContent>
    </div>
  );
};
